module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB9SURBVHgB7ZPBDYAgDEVr4wCOwApO5JFwdANG8EY4MokjuAIjMAHampp4rMEjPyk0hPfTwy9AowY+YowLXRvVpOQylbfWplEefK11ds5lDR1CMIh4UJtAJjjhox4GoVHdoBu8DQrHUwvJ38z9vQu0Bytle6d4GqVHYQb+0AUQ0CTjlC51LAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/sourceFile/check.png
// module id = K3AJ
// module chunks = 4